import {
  AGENT_CARD_INFO_TEXTS as platformTexts,
  type AgentCardInfoKey,
} from "../../../supabase/functions/_shared/platform-help-texts.ts";

/**
 * Overrides locais garantem textos novos na UI mesmo quando o dev server
 * ainda não recarregou platform-help-texts.ts (antes ignorado pelo watch do Vite).
 */
const UI_AGENT_CARD_INFO_OVERRIDES: Partial<Record<AgentCardInfoKey, string>> = {
  escalacao_agente:
    "Define quando este agente repassa o atendimento para outro agente de IA do workspace. Cada regra descreve a condição em linguagem natural e qual agente especialista assume. Diferente da transferência para humano: a conversa permanece ativa, o agente destino continua respondendo automaticamente e o lead não vai para fila humana. Use para rotear assuntos específicos (ex.: vendas → suporte técnico).",
};

export type { AgentCardInfoKey };

export const AGENT_CARD_INFO_TEXTS: Record<AgentCardInfoKey, string> = {
  ...platformTexts,
  ...UI_AGENT_CARD_INFO_OVERRIDES,
};
